var $1f5cea0742dc284a$exports = {};
$1f5cea0742dc284a$exports = {
  "previous": `Previous`,
  "next": `Next`,
  "selectedDateDescription": args => `Selected Date: ${args.date}`,
  "selectedRangeDescription": args => `Selected Range: ${args.dateRange}`,
  "todayDate": args => `Today, ${args.date}`,
  "todayDateSelected": args => `Today, ${args.date} selected`,
  "dateSelected": args => `${args.date} selected`,
  "startRangeSelectionPrompt": `Click to start selecting date range`,
  "finishRangeSelectionPrompt": `Click to finish selecting date range`,
  "minimumDate": `First available date`,
  "maximumDate": `Last available date`,
  "dateRange": args => `${args.startDate} to ${args.endDate}`
};
export { $1f5cea0742dc284a$exports as default };